// extracted by mini-css-extract-plugin
export default {"wrapper":"main-09_wrapper__ZwmDy","container":"main-09_container__msBFl","boxCard":"main-09_boxCard__7b0dD"};